<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-row>
      <v-col cols="12" sm="auto">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-top="-10"
          offset-y
          content-class="w-full md:w-96"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" x-large width="100%">
              <v-icon class="mr-2"> mdi-filter-variant </v-icon>
              Điều kiện lọc
            </v-btn>
          </template>
          <v-card class="px-8 pt-8 pb-2 flex flex-col space-y-4">
            <DatePicker
              v-model="startDate"
              @input="(value) => routeChange({ ...$route.query, startDate: value })"
              label="Từ ngày"
            />
            <DatePicker
              v-model="endDate"
              @input="(value) => routeChange({ ...$route.query, endDate: value })"
              label="Tới ngày"
            />
            <!-- <v-select
              v-model="sortCondition"
              :items="sortConditionList"
              class="text-left"
              label="Thứ tự mặc định"
              align-self="end"
              prepend-inner-icon="mdi-sort-alphabetical-descending"
              no-data-text="Không có dữ liệu"
              color="#FBB040"
              item-text="name"
              item-value="id"
              :hide-details="true"
              outlined
              @change="(value) => routeChange({ ...$route.query, sortCondition: value })"
              clearable
            /> -->

            <v-card-actions>
              <v-spacer />
              <v-btn text @click="menu = false"> Đóng </v-btn>
              <v-btn color="primary" text> Mặc định </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="auto" class="flex-grow" v-if="role == 'QuanLy'">
        <v-text-field
          v-model="searchString"
          hide-details="false"
          placeholder="Nội dung cần tìm"
          outlined
          color="#FBB040"
          prepend-inner-icon="mdi-magnify"
          @change="onSearch"
          clearable
        />
      </v-col>
      <v-col v-if="role != 'QuanLy'" cols="12" sm="auto" class="flex-grow">
        <v-text-field
          v-model="searchString"
          hide-details="false"
          placeholder="Nội dung cần tìm"
          outlined
          color="#FBB040"
          prepend-inner-icon="mdi-magnify"
          @change="onSearch"
          clearable
        />
      </v-col>
      <v-col v-if="role != 'QuanLy'" cols="12" lg="2" sm="3">
        <v-btn
          min-width="180"
          width="100%"
          block
          color="success"
          @click="onCreate"
          x-large
        >
          <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Tạo mới
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-8 mb-8">
      <v-col cols="12" lg="9" md="7" sm="8" :class="classStyle">
        <span class="text-lg font-medium">Tổng số: {{ totalItems }}</span>
      </v-col>
    </v-row>

    <v-skeleton-loader
      :loading="isLoading"
      transition="scale-transition"
      type="table"
      class="mx-auto"
    >
      <v-data-table
        id="myTable"
        item-key="id"
        :headers="headerTable"
        :items="list"
        :server-items-length="totalItems"
        :options.sync="options"
        no-data-text="Không có dữ liệu"
        no-results-text="Không có dữ liệu phù hợp"
        :footer-props="{
          itemsPerPageText: 'Dòng mỗi trang:',
          pageText: '{0}-{1} trên {2}',
          itemsPerPageAllText: 'Tất cả',
        }"
        class="elevation-1"
        @click:row="(item) => clickRow(item.id)"
        @update:page="updatePagination"
        @update:items-per-page="updatePagination"
      >
        <template v-slot:[`item.productName`]="{ item }">
          <v-chip color="purple" v-if="item.productName != null">
            <span class="white--text">{{ item.productName }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.customerPhone`]="{ item }">
          <v-chip color="brown" v-if="item.customerPhone != null">
            <span class="white--text">{{ item.customerPhone }}</span>
          </v-chip>
        </template>
        <template v-slot:[`item.productPriceFormat`]="{ item }">
          <v-chip color="green">
            <span class="white--text">{{ item.productPriceFormat }}</span>
          </v-chip></template
        >
        <template v-slot:[`item.productDateBuy`]="{ item }">
          <v-chip color="green">
            <span class="white--text">{{ item.productDateBuy }}</span>
          </v-chip></template
        >
        <template v-slot:[`item.customerName`]="{ item }">
          <v-chip color="orange">
            <span class="white--text">{{ item.customerName }}</span>
          </v-chip></template
        >
        <template #footer.prepend>
          <div class="flex-grow flex items-end justify-end mr-4">
            <span>
              <v-menu :max-height="400" :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on">mdi-cog-outline</v-icon>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in headers" :key="index">
                    <v-checkbox v-model="item.model" :label="item.text" />
                  </v-list-item>
                </v-list>
              </v-menu>
            </span>
          </div>
        </template>
      </v-data-table>
    </v-skeleton-loader>
    <v-row class="pt-5">
      <v-col cols="12" sm="auto">
        <v-btn
          min-width="180"
          width="100%"
          block
          color="success"
          @click="createPDF"
          x-large
        >
          <v-icon right dark class="mr-2"> mdi-plus-box </v-icon>
          Xuất file pdf
        </v-btn></v-col
      >
      <v-col cols="12" sm="auto">
        <vue-excel-xlsx
          :data="dataExcel"
          :columns="columns"
          class="btn success"
          :file-name="baoHanhExcelFileName"
          :file-type="'xlsx'"
          :sheet-name="'DỮ LIỆU BẢO HÀNH MÁY'"
        >
          XUẤT FILE EXCEL
        </vue-excel-xlsx></v-col
      ></v-row
    >
  </v-container>
</template>

<script>
import { EMPTY } from "~/utils/constants";
import { mapState } from "vuex";
import html2pdf from "html2pdf.js";
import DatePicker from "~/components/atoms/DatePicker.vue";

export default {
  name: "prescriptionBaseList",
  components: { DatePicker },
  data() {
    return {
      headers: [
        { text: "ID", value: "id", sortable: false, model: true },
        { text: "Sản phẩm", value: "productName", sortable: false, model: true },
        { text: "IMEI", value: "productIMEI", sortable: false, model: true },
        { text: "Tình trạng", value: "productStatus", sortable: false, model: true },
        { text: "Giá", value: "productPriceFormat", sortable: false, model: true },
        { text: "Ngày mua", value: "productDateBuy", sortable: true, model: true },
        { text: "Hình thức", value: "paymentMethod", sortable: true, model: true },
        { text: "Tên", value: "customerName", sortable: false, model: true },
        { text: "Số điện thoại", value: "customerPhone", sortable: false, model: true },
        { text: "Icloud", value: "customerCloud", sortable: false, model: true },
        { text: "Tạo lúc", value: "createdAt", sortable: false, model: true },
        { text: "Cập nhật lúc", value: "updatedAt", sortable: false, model: true },
      ],
      options: {
        page: 1,
        itemsPerPage: 5,
      },
      columns: [
        {
          label: "ID",
          field: "id",
        },
        {
          label: "MSP",
          field: "productIMEI",
        },
        {
          label: "Họ và tên",
          field: "customerName",
        },
        {
          label: "SĐT",
          field: "customerPhone",
        },
        {
          label: "Ngày mua",
          field: "productDateBuy",
        },
        {
          label: "Sản phẩm",
          field: "productName",
        },
        {
          label: "Tình trạng sản phẩm",
          field: "productStatus",
        },
        {
          label: "TK Icloud",
          field: "customerCloud",
        },
        {
          label: "Mật khẩu",
          field: "customerCloudPassword",
        },
        {
          label: "Bảo hành",
          field: "productGuarranName",
        },
        {
          label: "Giá bán",
          field: "productPrice",
        },
        {
          label: "HT Mua",
          field: "paymentMethod",
        },
        {
          label: "Ghi chú",
          field: "note",
        },
      ],
      dataExcel: [],
      list: [],
      menu: false,
      searchString: EMPTY,
      sortingList: [],
      totalItems: 0,
      isLoading: false,
      sortConditionList: [],
      sortCondition: 1,
      searchConditionList: [],
      searchCondition: 1,
      doctorId: null,
      elevatorBranchId: null,
      startDate: null,
      endDate: null,
      baoHanhExcelFileName: null,
    };
  },
  async created() {
    this.baoHanhExcelFileName =
      "bao-hanh-" + new Date().toLocaleDateString("vi-VN").replaceAll("/", "-");
    const headers = JSON.parse(localStorage.getItem("lephongbuy99"));
    if (headers) {
      this.headers = headers;
    }
    this.handleQueryParams();
    await Promise.all([
      this.getData(),
      this.getSortCondition(),
      this.getSearchCondition(),
    ]);
  },
  beforeDestroy() {
    localStorage.setItem("lephongbuy99", JSON.stringify(this.headers));
  },
  watch: {
    "$route.query": {
      async handler() {
        if (!Object.keys(this.$route.query).length) {
          this.options = { page: 1, itemsPerPage: 5 };
        }
        await this.getData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      role: (state) => state.user.roleName,
    }),
    classStyle() {
      return window.innerWidth <= 640 ? "pb-2" : "";
    },
    headerTable() {
      return this.headers.filter((item) => item.model);
    },
  },
  methods: {
    async routeChange(query) {
      // query not empty -> append current query
      const _query = { ...this.$route.query, ...query };
      Object.keys(query).forEach((element) => {
        if (!query[element] && typeof query[element] !== "boolean") {
          delete _query[element];
        }
      });

      this.$router.replace({ query: { ..._query } });
      if (this.options.page !== 1) {
        this.options.page = 1;
        return;
      }
      await this.getData();
    },
    clickRow(id) {
      this.$router.push({
        name: "PhoneBuyDetail",
        params: { phonbuyid: id },
      });
    },
    onCreate() {
      this.$router.push({ name: "CreatePhoneBuy" });
    },
    async handleQueryParams() {
      this.searchString = this.$route.query?.searchString || this.searchString;
      this.options.page = Number(this.$route.query?.page) || 1;
      this.options.itemsPerPage = Number(this.$route.query?.perPage) || 5;
    },
    onSearch() {
      this.options.page = 1;
      this.updateQueryParams();
    },
    async updateQueryParams() {
      const object = {};
      if (this.options.page) {
        object.page = this.options.page;
      }
      if (this.options.itemsPerPage) {
        object.perPage = this.options.itemsPerPage;
      }
      if (this.searchString) {
        object.searchString = this.searchString;
      }
      if (this.searchCondition) {
        object.searchCondition = this.searchCondition;
      }
      if (this.sortCondition) {
        object.sortCondition = this.sortCondition;
      }
      if (this.startDate) {
        object.startDate = this.startDate;
      }
      if (this.endDate) {
        object.endDate = this.endDate;
      }
      try {
        await this.$router.replace({ query: { ...object } });
      } catch {}
    },
    async getData() {
      try {
        this.isLoading = true;
        const { result, totalItems } = await this.$services.phonebuyService.getPhoneBuys({
          ...this.$route.query,
        });
        this.totalItems = totalItems;
        this.list = result;
        this.dataExcel = result;
      } catch (err) {
        this.list = [];
        this.totalItems = 0;
      } finally {
        this.isLoading = false;
      }
    },
    async updatePagination() {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          page: this.options.page,
          perPage: this.options.itemsPerPage,
        },
      });
    },
    async getSortCondition() {
      try {
        const data = await this.$services.phonebuyService.getPhoneBuySortCondition();
        this.sortConditionList = data;
      } catch (err) {
      } finally {
      }
    },
    async getSearchCondition() {
      try {
        const data = await this.$services.phonebuyService.getPhoneBuySearchCondition();
        this.searchConditionList = data;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    onClickDefault() {
      this.searchCondition = 1;
      this.sortCondition = 1;
      this.onSearch();
    },
    createPDF() {
      html2pdf() // move your config in the .set({...}) function below
        .set({
          filename: "filename",
          html2canvas: {
            dpi: 192,
            scale: 5,
            letterRendering: true,
            useCORS: true,
          },
          jsPDF: {
            unit: "mm",
            format: "a2",
            orientation: "landscape",
          },
        })
        .from(document.getElementById("myTable"))
        .outputPdf() // add this to replace implicite .save() method, which triggers file download
        .get("pdf")
        .then(function (pdfObj) {
          window.open(pdfObj.output("bloburl"), "F");
        });
    },
  },
};
</script>
<style scoped>
.btn {
  border: 2px solid black;
  background-color: white;
  color: black;
  padding: 14px 32px;
  font-size: 16px;
  cursor: pointer;
  color: white !important;
}

/* Green */
.success {
  border-color: #04aa6d;
  color: green;
}

.success:hover {
  background-color: #04aa6d;
  color: white;
}
</style>
